<template>
    <div :class="[
        {'no-header': !isLogoutRoute && !showDesktop}, 
        {'mobile': !showDesktop},
        {'default main-con': true}
    ]">

        <base-menu
            v-if="isAuthenticated && !this.showDesktop"
            class="show-nav bottom-nav mobile-main-nav bottom-nav--public"
            item-class="flex-direction-column"
            :menu="mobile_bottom_menu"
        />
        <div class="banner-wrapper" v-if="showDesktop">
            <div class="banner-contained con-wrapper">
                <main-header v-if="showDesktop" />
                <div v-if="pageTitle" class="page-con-header custom-page-pch">
                  <a href="#" class="color-pink back-link mobile-title" @click.prevent.stop="handleBackClick">
                    <svg height="36" width="36" class="t-icon chevron-left icon-svg"></svg>
                  </a>
                  <h3 class="color-pink color-pink pub-headers">{{ pageTitle | translate }}</h3>
                </div>
                <div :class="`content-con ${withAccordion ? 'with-accordion' : ''} ${wrapContent ? 'df-wrap' : ''}`">
                    <div class="con-wrapper">
                        <slot name="content"></slot>
                        <div v-if="items.length" class="content accordion-content">
                            <template v-if="isAccordionGroup">
                                <accordion-group>
                                    <li v-for="(item, index) in items" :key="index" class="accordion_group" v-bind:class="{'accordion_group-active': (currentSel === index)}">
                                        <accordion-item
                                            v-if="!item.use_slot_content"
                                            :title="item.question"
                                            :content="item.answer"
                                            :index="index"
                                            :currentItem="currentSel"
                                            @onSelectItem="onSelectItem"
                                            @agBeforeEnter="agBeforeEnter"
                                            @agOnEnter="agOnEnter"
                                            grouped
                                        ></accordion-item>
                                        <accordion-item
                                            v-else
                                            :use-slot-content="true"
                                            :custom-container="item.custom_container"
                                            :title="item.question"
                                            :index="index"
                                            :currentItem="currentSel"
                                            @onSelectItem="onSelectItem"
                                            @agBeforeEnter="agBeforeEnter"
                                            @agOnEnter="agOnEnter"
                                            grouped
                                        >
                                            <template slot="acc-content">
                                                <slot :name="`slot-item-${index}`"></slot>
                                            </template>
                                        </accordion-item>
                                    </li>
                                </accordion-group>
                            </template>
                            <!-- // not group -->
                            <template v-else v-for="(item, key) in items">
                                <accordion-item :key="key" :title="item.question" :content="item.answer"></accordion-item>
                            </template>
                            <slot name="content-after-accordion"></slot>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <template v-else>
            <div v-if="isLogoutRoute" :class="[{'has-header': isLogoutRoute}, 'top-nav-con']" >
                <div class="logo-con">
                    <router-link :to="{ name: 'home' }">
                        <img class="img-responsive" :src="`${icdn_url}/desktop-logo.png`" :alt="`Logo ${site_name}`" v-cloak>
                    </router-link>
                </div>
            </div>

            <div :class="[
                {'no-header': !isLogoutRoute && !showDesktop}, 
                { 'with-accordion' : withAccordion}, 
                { 'df-wrap': wrapContent },
                {'content-con': true}
            ]">
                <div class="con-wrapper">
                    <div v-if="pageTitle" class="page-con-header custom-page-pch">
                      <div class="mobile-back-link">
                        <a href="#" class="page-header-3 back-link mobile-title" @click.prevent.stop="handleBackClick">
                          <svg height="36" width="36" class="t-icon chevron-left icon-svg"></svg>
                        </a>
                        <h3 class="color-pink">{{ pageTitle | translate }}</h3>
                      </div>
                    </div>
                    <slot name="content"></slot>
                    <div v-if="withAccordion && items.length" class="content accordion-content">
                        <template v-if="isAccordionGroup">
                            <accordion-group>
                                <li v-for="(item, index) in items" :key="index" class="accordion_group" v-bind:class="{'accordion_group-active': (currentSel === index)}">
                                    <accordion-item
                                        v-if="!item.use_slot_content"
                                        :title="item.question"
                                        :content="item.answer"
                                        :index="index"
                                        :currentItem="currentSel"
                                        @onSelectItem="onSelectItem"
                                        @agBeforeEnter="agBeforeEnter"
                                        @agOnEnter="agOnEnter"
                                    ></accordion-item>
                                    <accordion-item
                                        v-else
                                        :use-slot-content="true"
                                        :custom-container="item.custom_container"
                                        :title="item.question"
                                        :index="index"
                                        :currentItem="currentSel"
                                        @onSelectItem="onSelectItem"
                                        @agBeforeEnter="agBeforeEnter"
                                        @agOnEnter="agOnEnter"
                                    >
                                        <template slot="acc-content">
                                            <slot :name="`slot-item-${index}`"></slot>
                                        </template>
                                    </accordion-item>
                                </li>
                            </accordion-group>
                        </template>
                        <!-- // not group -->
                        <template v-else v-for="(item, index) in items">
                            <accordion-item :title="item.question" :content="item.answer" :key="index"></accordion-item>
                        </template>
                        <slot name="content-after-accordion"></slot>
                    </div>
                </div>
            </div>
        </template>
        <main-footer />
    </div>
</template>

<script>
    import MainHeader from '@theme-views/common/MainHeader'
    import MainFooter from '@theme-views/common/MainFooter'
    import MobileMenu from '@theme-views/common/MobileMenu'
    import AccordionItem from '@theme-views/common/AccordionItem'
    import AccordionGroup from '@theme-views/common/AccordionGroup'
    import BaseMenu from '@theme-views/common/BaseMenu'
    import SvgStar from '@theme-views/common/SvgIcon/Icons/Star'
    import Default from '@views/public/layouts/Default/default'
    import {handleBackBtn} from '@/helpers'

    export default {
        mixins: [Default, AccordionGroup],
        data() {
            return {
                mobile_menu_opened: false,
                mobile_bottom_menu: [
                {
                  name:'Home',
                  route: 'user-home',
                  svg_icon: {
                    name: 'home',
                    width: 27,
                    height: 27,
                    color: '#c5c5c5'
                  }
                },
                {
                  name:'Messages',
                  route: 'user-messages',
                  svg_icon: {
                    name: 'envelope',
                    id: 2,
                    width: 29,
                    height: 28,
                    color: '#c5c5c5'
                  }
                },
                {
                  name:'Favorites',
                  route: 'user-favorites',
                  svg_icon: {
                    name: 'star',
                    width: 28,
                    height: 28,
                    color: '#c5c5c5'
                  }
                },
                {
                  name:'Profile',
                  route: 'user-mobile-home',
                  svg_icon: {
                    name: 'profile',
                    width: 24,
                    height: 28,
                    color: '#c5c5c5'
                  }
                }
              ],
              site_name: window.APP_CONFIG.DOMAIN_NAME,
            }
        },
        props: {
            iconLeft: {
                type: String,
                default: 'icon-pointer-left-white'
            },
            wrapContent: {
                type: Boolean,
                default: false
            },
            backFallbackRoute: {
                type: Object,
                default: () => {
                    {}
                }
            },
            isAccordionGroup: {
              type: Boolean,
              default: false
            },
            pageTitle: {
                type: String,
                default: ''
            }
        },
        methods: {
            populateUnreadMessage(val) {
                this.addUnreadCount( this.mobile_bottom_menu, val)
            },
            addUnreadCount(menu, val) {
                let item = menu.find( (val,key) => {
                    if(val.route == 'user-messages') return val
                })
                item.sub_title = !val ? null : val.toString()
                if(item.icon_class && val) {
                    item.icon_class = 'icon icon-message-full'
                } else if(item.icon_class) {
                    item.icon_class = 'icon icon-message-grey'
                }
            },
            openMobileMenu() {
                if(this.$refs['mobile-menu']) {
                    this.$refs['mobile-menu'].openMenu()
                    this.mobile_menu_opened = this.$refs['mobile-menu'].opened
                }
            },
            handleBackClick() {
                handleBackBtn(this.$router, this.routeFrom, this.backFallbackRoute)
            }
        },
        computed: {
            unread_messages() {
                let i = this.$store.getters['auth/profile']['welcome_message'] == 1 ? 1 : 0
                return parseInt(this.$store.getters['auth/unreadMessages']) + i
            },
            routeFrom() {
                return this.$store.getters['pub/routeFrom']
            },
            hasContentSlot () {
              return !!this.$slots['content']
            },
            isAuthenticated() {
                return this.$store.getters['auth/isAuthenticated']
            },
            isLogoutRoute() {
                return this.$route.name === 'logged-out'
            }
        },
        watch: {
            unread_messages(to,from) {
                this.populateUnreadMessage(to)
            },
            '$route' (to, from) {
                if(this.$refs['mobile-menu']) {
                    this.mobile_menu_opened = false
                    this.$refs['mobile-menu'].closeMenu()
                }
            }
        },
        mounted() {
            this.populateUnreadMessage(this.unread_messages)
        },
        components: {
            MainHeader,
            MainFooter,
            MobileMenu,
            BaseMenu,
            AccordionItem,
            AccordionGroup,
            SvgStar,
        }
    }
</script>

<style lang="scss" >
.default {
	.top-nav-con {
		padding-bottom: 40px !important;
	}

	&.main-con {
			background-size: cover;
			background-repeat: no-repeat;
			background-position: 100% 100%;
			background-color: #fff;
			position: relative;
			z-index: 2;
			
			&.no-header.mobile .page-con-header {
					margin-top: 50px;
			}

      .pub-headers {
        text-align: center;
        white-space: pre-wrap;
        width: 100%;
        padding: 0 20px;
        font-family: "Poppins";
        font-size: 24px !important;
        font-weight: 600 !important;
        text-transform: uppercase;
        margin-bottom: 0;
      }

			&:before {
					content: " ";
					background-size: cover;
					background-image: var(--img-bg-transparent-o);
					background-color: var(--poly-primary);
					background-repeat: no-repeat;
					position: absolute;
					height: 100%;
					width: 100%;
					z-index: 1;
					@media #{$big-screen} {
						background-size: cover;
					}
			}
			.main-footer {
					z-index: 5;
			}
			.content-con {
					position: relative;
					z-index: 5;

					&.df-wrap {
							padding-left: 0;
							padding-right: 0;
							> .con-wrapper {
									z-index: 4;
									border-radius: 20px;
									background-color: #fff;
									margin-bottom: 100px;
									margin-top: 12px;
									> .content {
											padding: 32px;
									}
							}
					}
			}
			@media(max-width: 1199px) {
					.content-con {
							.title-con {
									> h4 {
											color: var(--sd-secondary-normal);
											margin-bottom: 20px;
											font-size: 22px;
											@include font-settings(normal, normal, normal, 28px, 600);
									}
							}
							> .con-wrapper {
									padding: 0 20px 0 !important;
							}
							&.df-wrap {
									> .con-wrapper {
											border-radius: 3px;
											box-shadow: none;
											background-color: #fff;
											margin-top: 0;
											margin-bottom: 20px;
											padding: 0 20px;
									}
							}
							&.with-accordion {
									padding: 10px 20px;
									.con-wrapper {
											padding: 0 !important;
											width: 100%;
											.accordion-item {
													margin-bottom: 15px;
													.acc-title-con  {
															padding: 18px 50px;
															text-transform: initial;
															font-size: 15px;
															font-weight: 500;
															line-height: 1.5;
													}
											}
									}
							}
					}
			}
		.page-con-header {
			.back-link {
				font-family: $font-primary;
				margin: 0;
        position: absolute;
        left: 0;
				svg {
					background-color: #797979;
					margin-right: 0;
				}
			}
		}
		.mobile-back-link {
			display: flex;
			align-items: center;
			justify-content: center;
			width: 100%;
			position: relative;
			svg {
					margin-right: 0;
			}
			.back-link {
					position: absolute;
					bottom: 0;
			}

			h3 { 
					margin-bottom: 0!important; 
					width: 100%;
					max-width: 100%;
					padding: 0 20px;
			}
		}
	}
}
</style>
